import { el, setChildren, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import TextInputRenderer from './renderers/text';
import EmailInputRenderer from './renderers/email';
import NumberInputRenderer from './renderers/number';
import TextAreaInputRenderer from './renderers/textarea';
import SelectInputRenderer from './renderers/select';
import CheckboxGroupRenderer from './renderers/checkbox-group';
import RadioButtonGroupRenderer from './renderers/radio-button-group';
import FileInputRenderer from './renderers/file';

import fieldTypes from '../field-types';

import editIconString from 'assets/images/edit-icon.svg?raw';

const editIcon = stringToSVG(editIconString);

const inputRenderers = {
  [fieldTypes.TEXT]: TextInputRenderer,
  [fieldTypes.EMAIL]: EmailInputRenderer,
  [fieldTypes.NUMBER]: NumberInputRenderer,
  [fieldTypes.TEXT_AREA]: TextAreaInputRenderer,
  [fieldTypes.SELECT]: SelectInputRenderer,
  [fieldTypes.CHECKBOX_GROUP]: CheckboxGroupRenderer,
  [fieldTypes.RADIO_BUTTON_GROUP]: RadioButtonGroupRenderer,
  [fieldTypes.FILE]: FileInputRenderer
};

class FormFieldRow {

  constructor(formEditor) {

    this.index = null;
    this.fieldRow = null;
    this.inputRenderer = null;
    this.formEditor = formEditor;

    this.label = null;

    this.el = el('.form-editor-field-row-main', [
      el('.form-editor-field-row-auto-elements', [
        el('.form-editor-field-label-row', [
          this.renderLabel(),
          this.renderEditButton()
        ]),
        this.renderInputContainer()
      ])
    ]);

  }

  renderLabel() {

    this.label = el('label.form-editor-field-row-label', {
      class: 'field-label'
    });

    return this.label;

  }

  renderInputContainer() {

    this.inputContainer = el('div.form-editor-field-row-input-container');

    return this.inputContainer;

  }

  renderEditButton() {

    const editButton = el('button.form-editor-field-row-edit-button', {
      onclick: this.handleEditButtonClick.bind(this)
    }, [
      editIcon.cloneNode(true)
    ]);

    return editButton;

  }

  handleEditButtonClick() {

    this.formEditor.handleEditFieldRow(this.index);

  }

  updateLabel() {

    this.label.textContent = this.fieldRow.label;

  }

  updateInput() {

    let inputRenderer = this.inputRenderer;
    const InputRenderer = inputRenderers[this.fieldRow.type];

    if ((inputRenderer instanceof InputRenderer) === false) {
      inputRenderer = this.inputRenderer = new InputRenderer();
      setChildren(this.inputContainer, [inputRenderer]);
    }

    inputRenderer.update(this.fieldRow.options, this.fieldRow);

  }

  update(fieldRow, index) {

    this.fieldRow = fieldRow;
    this.index = index;

    this.updateLabel();
    this.updateInput();

    setAttr(this.el, {
      'data-id': this.fieldRow._id
    });

  }

}

export default FormFieldRow;